export default __webpack_public_path__ + "static/media/product-04.6fe2d4e7.jpg";